import React from "react";
import TablePurchases from "../../components/Tables/purchases";

const Purchases = () => {
  return (
    <TablePurchases isPage={true} />
  );
};
export default Purchases;
